export default __webpack_public_path__ + "static/media/delaware.38d96396.jpg";